const STORAGE_KEY_PREFIX = "freshpaint:profileNamePromptSeen";

// Scoped per user so one person dismissing the prompt on a shared browser
// (or a Freshpaint employee masquerading) doesn't suppress it for the next.
function storageKey(uid: string): string {
  return `${STORAGE_KEY_PREFIX}:${uid}`;
}

export function hasSeenProfileNamePrompt(uid: string): boolean {
  return localStorage.getItem(storageKey(uid)) === "true";
}

export function markProfileNamePromptSeen(uid: string): void {
  localStorage.setItem(storageKey(uid), "true");
}
